import type { ActionFunctionArgs } from '@remix-run/node';
import { getModuleProduct } from '@modules/page-builder/api/get-module-product.server';
import invariant from 'tiny-invariant';

export const loader = async ({ request, context }: ActionFunctionArgs) => {
    const url = new URL(request.url);
    const ids = url.searchParams.getAll('productId');
    if (!ids || !ids.length) {
        invariant(ids, 'productId not found.');
    }
    const idValues = ids.map((id) => parseInt(id));

    const result = await getModuleProduct({ ...context, IDs: idValues });

    if (!result) {
        return null;
    }

    return result;
};

export type PageBuilderGetModuleProductAction = typeof loader;

export const QUERY_MODULE_PRODUCT =
    '/remix-api/page-builder/get-module-product';
